module.exports = __webpack_public_path__ + "media/uk_ua_s1_Maryska.41b945ce.oga";